/* eslint-disable class-methods-use-this */
export default class QuantityManipulator extends EventTarget {
  constructor() {
    super();
    this.initQtyController();
  }

  static updateCartCount(quantity) {
    [...document.querySelectorAll('.cart-count-js')].forEach((node) => {
      node.innerText = quantity;
    });
  }

  async setQtyValue(itemId, value, previousValue = 0) {
    [...document.querySelectorAll(`.cart__qty-controller[data-item-key="${itemId}"] .cart__qty-input`)].forEach(
      (node) => {
        node.value = value;
      },
    );

    try {
      await this.updateQuantity(itemId, value, previousValue);
      EasyPoints.Tiers.recalculate();
    } catch (e) {
      console.warn(e.message);
    }
  }

  increaseQty(itemId, qtyInput) {
    const value = parseInt(qtyInput.value, 10);
    this.setQtyValue(itemId, value + 1, value);
  }

  decreaseQty(itemId, qtyInput) {
    if (qtyInput.value > 1) {
      const value = parseInt(qtyInput.value, 10);
      this.setQtyValue(itemId, value - 1, value);
    }
  }

  setLoadingCartItems() {
    const node = document.querySelector('[data-cart-items]');
    node.style.opacity = '0.5';
  }

  initQtyController() {
    const cartForm = document.querySelector('#CartForm');

    if (cartForm) {
      // Main Cart
      const mainDecreaseButton = [...cartForm.querySelectorAll('[decrease-qty-controller]')];
      const mainIncreaseButton = [...cartForm.querySelectorAll('[increase-qty-controller]')];
      const mainRemoveButton = [...cartForm.querySelectorAll('a[cart-delete-item]')];
      const mainQtyInput = [...cartForm.querySelectorAll('.cart__qty-input')];

      for (let i = 0; i < mainQtyInput.length; i += 1) {
        const input = mainQtyInput[i];
        const { itemKey } = input.parentElement.dataset;
        mainDecreaseButton[i].onclick = () => {
          this.decreaseQty(itemKey, input);
        };
        mainIncreaseButton[i].onclick = () => {
          this.increaseQty(itemKey, input);
        };
        mainRemoveButton[i].onclick = () => {
          this.setLoadingCartItems();
        };
      }
    }
  }

  async updateQuantity(itemId, quantity, previousValue) {
    const data = { id: itemId, quantity };

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const cart = await response.json();
    QuantityManipulator.updateCartCount(cart.item_count - SolarisCart.protectionsItemsInCart()?.length);

    this.dispatchEvent(
      new CustomEvent('update-cart', {
        detail: {
          itemId,
          cart,
          change: quantity - previousValue,
        },
      }),
    );

    return cart;
  }
}
